import styled from 'styled-components'

import { TypeStyle } from '@syconium/little-miss-figgy'

export const Body = styled.div`
  border-bottom: 1px solid ${o => o.theme.color.deprecated.stoneLight};
  box-sizing: border-box;
  padding: 0 1rem;
`

export const SummaryWrap = styled.div`
  cursor: pointer;
  overflow-x: hidden;
`

export const Summary = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 24px 0;
  width: 100%;
`

export const Label = styled(TypeStyle.HeadlineExtraExtraSmall)`
  text-transform: uppercase;
`

export const Details = styled.div`
  padding-bottom: 10px;
`
